// extracted by mini-css-extract-plugin
export const slider_main = "blog-module--slider_main--1M5eO";
export const slider_card = "blog-module--slider_card--3L-kt";
export const Readd = "blog-module--Readd--1dtN3";
export const slider_cardcontent = "blog-module--slider_cardcontent--2zSwO";
export const slider_belowbtn1 = "blog-module--slider_belowbtn1--3qPlV";